var card_product_media_default = (() => {
    if (customElements.get("card-product-media")) return;
    const slidePositionLabel = (index, total) => (window.MBF?.strings?.card?.gallery?.slidePosition || "__index__ of __total__").replace(/__index__/g, index).replace(/__total__/g, total);
    customElements.define("card-product-media", class CardProductMedia extends HTMLElement {
        connectedCallback() {
            this.track = this.querySelector("[data-track]");
            this.prev = this.querySelector("[data-prev]");
            this.next = this.querySelector("[data-next]");
            this.slides = Array.from(this.querySelectorAll("[data-slide]"));
            this.status = this.querySelector("[data-status]");
            this.mediaRoot = this.closest(".product-card__media");
            if (!this.track || this.slides.length === 0) return;
            this.visible = new Set;
            this.current = 0;
            this.visibilityObserver = new IntersectionObserver(this.handleVisibility.bind(this), {
                root: this.track,
                threshold: .6
            });
            for (const slide of this.slides) this.visibilityObserver.observe(slide);
            this.preload(0);
            this.preload(1);
            this.prev?.addEventListener("click", this);
            this.next?.addEventListener("click", this);
            this.syncSlideA11y();
            this.swapped = this.dataset.mediaLead === "lifestyle";
            const gridImage = this.closest(".product-grid-wrapper")?.dataset.image;
            if (gridImage && gridImage === "lifestyle" !== this.swapped) {
                this.swapSlides(0, 1);
                this.swapped = gridImage === "lifestyle";
            }
            document.addEventListener("plp-toggle:change", this);
            this.setAttribute("data-upgraded", "");
            this.syncOnCutout();
        }
        disconnectedCallback() {
            this.visibilityObserver?.disconnect();
            clearTimeout(this.announceTimer);
            this.prev?.removeEventListener("click", this);
            this.next?.removeEventListener("click", this);
            document.removeEventListener("plp-toggle:change", this);
        }
        handleEvent(event) {
            if (event.type === "plp-toggle:change") {
                const {control: control} = event.detail || {};
                if (control === "image") return this.handleToggleChange(event);
                if (control === "layout") return this.handleLayoutChange(event);
                return;
            }
            if (event.type !== "click") return;
            const button = event.currentTarget;
            if (button?.getAttribute("aria-disabled") === "true") return;
            const direction = button === this.next ? 1 : -1;
            const step = this.slides[0]?.clientWidth || this.track.clientWidth;
            this.track.scrollBy({
                left: direction * step,
                behavior: "smooth"
            });
        }
        handleToggleChange(event) {
            const detail = event.detail || {};
            if (detail.control !== "image") return;
            if (!event.target || !event.target.contains(this)) return;
            const wantLifestyle = detail.value === "lifestyle";
            if (wantLifestyle !== this.swapped) {
                this.swapSlides(0, 1);
                this.swapped = wantLifestyle;
            }
            this.syncOnCutout();
        }
        handleLayoutChange(event) {
            if (!event.target || !event.target.contains(this)) return;
            this.track.scrollLeft = 0;
            this.current = 0;
            this.preload(0);
            this.updateArrows();
            this.syncOnCutout();
        }
        swapSlides(a, b) {
            const list = this.slides;
            if (a === b || a < 0 || b < 0 || a >= list.length || b >= list.length) return;
            const elA = list[a];
            const elB = list[b];
            const parent = elA.parentNode;
            const holderA = document.createComment("swap");
            const holderB = document.createComment("swap");
            parent.insertBefore(holderA, elA);
            parent.insertBefore(holderB, elB);
            parent.replaceChild(elB, holderA);
            parent.replaceChild(elA, holderB);
            this.slides = Array.from(this.querySelectorAll("[data-slide]"));
            this.visibilityObserver.disconnect();
            this.visible.clear();
            for (const slide of this.slides) this.visibilityObserver.observe(slide);
            this.track.scrollLeft = 0;
            this.current = 0;
            this.preload(0);
            this.preload(1);
            this.updateArrows();
            this.syncSlideA11y();
            this.syncOnCutout();
        }
        syncOnCutout() {
            const cutoutIndex = this.swapped && this.slides.length > 1 ? 1 : 0;
            this.mediaRoot?.toggleAttribute("data-on-cutout", this.current === cutoutIndex);
        }
        syncSlideA11y() {
            const total = this.slides.length;
            this.slides.forEach((slide, index) => {
                slide.setAttribute("aria-label", slidePositionLabel(index + 1, total));
                const link = slide.querySelector("a");
                if (index === 0) link?.removeAttribute("tabindex"); else link?.setAttribute("tabindex", "-1");
            });
        }
        announce() {
            if (!this.status) return;
            clearTimeout(this.announceTimer);
            this.announceTimer = setTimeout(() => {
                this.status.textContent = slidePositionLabel(this.current + 1, this.slides.length);
            }, 100);
        }
        preload(index) {
            const slide = this.slides[index];
            if (!slide) return;
            const img = slide.querySelector("img[data-src]");
            if (!img) return;
            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
                img.removeAttribute("data-srcset");
            }
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
            const reveal = () => img.classList.add("is-loaded");
            if (img.complete && img.naturalWidth > 0) reveal(); else {
                img.addEventListener("load", reveal, {
                    once: true
                });
                img.addEventListener("error", reveal, {
                    once: true
                });
            }
        }
        handleVisibility(entries) {
            for (const entry of entries) {
                const index = this.slides.indexOf(entry.target);
                if (index === -1) continue;
                if (entry.isIntersecting) this.visible.add(index); else this.visible.delete(index);
            }
            if (this.visible.size > 0) {
                const current = Math.min(...this.visible);
                const changed = current !== this.current;
                this.current = current;
                this.preload(this.current + 1);
                if (changed) {
                    this.announce();
                    this.syncOnCutout();
                }
            }
            this.updateArrows();
        }
        updateArrows() {
            const lastIndex = this.slides.length - 1;
            const atStart = this.visible.has(0) || this.track.scrollLeft <= 0;
            const atEnd = this.visible.has(lastIndex);
            this.prev?.setAttribute("aria-disabled", String(atStart));
            this.next?.setAttribute("aria-disabled", String(atEnd));
        }
    });
})();